var _defs, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoOpportunita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.1 62.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #004996;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 29,
    cy: 28.6,
    rx: 6.9,
    ry: 6.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,11V1.5M20.1,13.4l-4.8-8.2M52.8,42.4l-8.3-4.7M13.5,19.9l-8.3-4.7M56.5,28.8h-9.6M11.1,28.8H1.5M52.8,15.1l-8.3,4.7M13.5,37.7l-8.3,4.7M42.8,5.2l-4.8,8.2M38.6,60.8v-10.7M19.5,60.8v-10.7M13.5,60.8v-13.7c0-2.5,1.5-4.7,3.9-5.5l5.7-2.1,6,5.9,6-5.9,5.7,2.1c2.3.9,3.9,3.1,3.9,5.5v13.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoOpportunita);
export default __webpack_public_path__ + "static/media/emo-opportunita.5805dfa441d39b621b73bf8695657cba.svg";
export { ForwardRef as ReactComponent };